import React, { Fragment } from 'react';

import { makeClassNames } from '../../../utils/styles';
import PlayerCardChart, { IPlayerCardChart } from '../../molecules/player-card-chart/player-card-chart';
import './player-cards-chart.scss';

export interface IPlayerCardsChart {
  cardsChart: IPlayerCardChart[];
}

const classNames = () =>
  makeClassNames({
    wrapper: 'player-cards-chart__wrapper',
    element: 'player-cards-chart__element',
    divider: 'player-cards-chart__divider',
  });

const PlayerCardsChart = ({ cardsChart }: IPlayerCardsChart) => {
  const cn = classNames();

  return (
    <div className={cn.wrapper}>
      {cardsChart.map((card, index) => (
        <Fragment key={index}>
          <div className={cn.element}>
            <PlayerCardChart {...card} />
          </div>
          {index + 1 !== cardsChart.length && <div className={cn.divider} />}
        </Fragment>
      ))}
    </div>
  );
};

export default PlayerCardsChart;
